<template>
	<c-loader class="c-project-list" v-if="!blogLoaded" />
	<div class="view-wrapper post" v-else>
		<div class="post__hero" :style="'background-image:url(' + post.featuredImageUrl + ')'" v-if="post.featuredImageUrl"></div>
		<div class="container">
			<div class="post__meta">
				<span class="post__date">{{ post.transformedDate }}</span><br>
				<h1>{{ post.title }}</h1>
			</div>

			<div class="post__content">
				<c-flex-content :content="post.flex_content"></c-flex-content>
			</div>

			<div class="post__footer">
				<div class="post_footer-content" v-if="post.isVRBriefing" v-html="blog_article_footer" />
				<div class="post_footer-content" v-if="post && post.blog_post_bildquelle">
					<p class="post_footer-bildquelle">{{ post.blog_post_bildquelle }}</p>
				</div>
			</div>

		</div>
		<div class="post__related">
			<div class="container">
				<h2>{{ localizedRelatedPostsText }}</h2>
			</div>
			<c-blog-posts-list :posts='featuredPosts' button="allPosts" compact="true" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as utils from '@/utils/utils';
import defaultHeadData from '@/utils/defaultHeadData';
import { getBlogPostBySlug } from '@/api/blog.wp.api'
import CBlogPostsList from '@/components/BlogPostsList';
import CFlexContent from '@/components/FlexContent';
import CLoader from '@/components/Loader'

export default {
	name: 'blog-post',
	components: {
		CBlogPostsList,
		CFlexContent,
		CLoader
	},
	data: () => ({
		uid: null,
		postData: {},
		headData: defaultHeadData,
		relatedPostsText: {
			'en-us': 'Latest Posts',
			'de-ch': 'Neuste Beiträge'
		},
		loaded: false
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		post() {
			return this.postData
		},
		localizedRelatedPostsText() {
			return this.relatedPostsText[this.settings.currentLang]
		},
		blog_article_footer() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].blog_article_footer
		},
		...mapGetters(['blogLoaded', 'featuredPosts'])
	},
	watch: {
		'$route': function() {
			this.uid = this.$store.state.route.params.post
			this.fetchPostData()
			utils.setHtmlLang(this.settings.currentLang)
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: false })
		}
	},
	beforeMount() {
		this.uid = this.$store.state.route.params.post
		this.fetchPostData()
	},
	methods: {
		fetchPostData() {
			getBlogPostBySlug(this.uid).then(post => {
				this.loaded = false;
				if (post) {
					this.postData = post
					this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/blog/' + post.slug})
					this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en'})
					utils.setHtmlLang(this.settings.currentLang)
					this.updateHeadData()
					this.loaded = true;
				} else {
					this.$router.push(this.settings.currentLang == 'en-us' ? '/en/404' : '/404')
				}
			}).catch(err => this.$router.push(this.settings.currentLang == 'en-us' ? '/en/404' : '/404'))
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.post) {
				this.headData = utils.transformHeadData({
					meta: this.post.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		}
	}
}
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	$maxContentWidth: 45rem;

	.post {
		padding-bottom: 6rem;

		&__hero {
			height: 17rem;
			width: 100%;
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
			max-width: 80rem;
			margin: 0 auto;

			@include mq($from: medium) {
				height: 28rem;
				margin-top: -3rem;
			}
		}

		.c-flex-content__image-wrapper--full {
			max-width: 45rem;
		}

		.c-flex-content__slice--html_snippet {
			position: relative;
			width: 100%;
			max-width: 45rem;
		}


		//
		// &__content-slice {
		// 	margin: 2rem 0;
		//
		// 	&--images {
		// 		display: flex;
		// 		flex-wrap: wrap;
		// 		justify-content: space-between;
		// 	}
		// }
		// &__image {
		// 	width: 100%;
		// 	height: auto;
		// }
		// &__image-wrapper {
		// 	margin: 0;
		// 	margin-bottom: 1rem;
		//
		// 	&--half {
		// 		width: 100%;
		//
		// 		@include mq($from: medium) {
		// 			width: 49%;
		// 		}
		// 	}
		// 	&--full {
		// 		width: 100%;
		// 	}
		// 	figcaption {
		// 		font-size: .8rem;
		// 		color: #888;
		//
		// 		p {
		// 			margin: 0;
		// 		}
		// 	}
		// }






		&__meta {
			margin-top: -4rem;
			margin-bottom: 3rem;
			margin-left: -1rem;
		}
		&__date {
			display: inline-block;
			margin: 0;
			font-size: 1rem;
			color: #888;
			background-color: #fff;
			padding: 0 1rem;
			font-weight: 600;
		}
		p {
			max-width: $maxContentWidth;
			margin: .75rem 0;
			line-height: 1.6;
		}
		h1 {
			display: inline-block;
			margin-bottom: 0;
			line-height: 1.2;
			max-width: 45rem;
			background-color: #fff;
			padding: 0 1rem;
		}
		h2, h3 {
			font-weight: 600;
			margin-top: 3rem;
			margin-bottom: .5rem;
			line-height: 1.2;
			max-width: $maxContentWidth;

			@include mq($from: medium) {
				margin-bottom: 1.5rem;
			}
		}
		h3 {
			font-size: 1.25rem;
		}
		.c-embed {
			max-width: $maxContentWidth;
			margin: 2rem 0;

			@include mq($from: medium) {
				margin: 3rem 0;
			}
		}

		&__related {
			margin-top: 4rem;

			h2 {
				margin-bottom: 2rem;
				color: $colorBrandMain;
			}
			h3 {
				margin-top: 0;
				margin-bottom: 0;
				line-height: 1.4;
			}
			p {
				margin: 0;
			}

			@include mq($from: medium) {
				margin-top: 6rem;
			}
		}

		&_footer-bildquelle {
			color: #83929C;
		}

		&__content {
			ul {
				max-width: $maxContentWidth;
				font-family: $fontFamilySerif;
				margin: .75rem 0;
				line-height: 1.6;
				list-style: disc outside none;
				margin-left: 1em;
			}

			ol {
				display: table;
				margin-left: 0;
				padding-left: 0;
				list-style: none;

				li {
					display: table-row;
					counter-increment: table-ol;

					&:before {
						content: counter(table-ol) ".";
						display: table-cell;
						padding-right: 0.8em;
						text-align: right;
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// BlogPost.vue?45c625a4